import { URI_FINANCIAL_ACCOUNT } from '@/config/config';

export default async ({ rootState }, payload) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  };
  const response = await fetch(`${URI_FINANCIAL_ACCOUNT}creditors`, opts);

  if (response.status === 204) {
    return;
  }
  const jsonResult = await response.json();

  if (jsonResult.status === 'error') {
    console.error(jsonResult);
    return Promise.reject(jsonResult.message);
  }
  return jsonResult.data;
};
